import { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { CountriesContext } from "../../context/countries.context";
import { ModeContext } from "../../context/mode.context";
import "./country-data.component.scss";

const CountryData = ({ country }) => {
  const {
    nativeName,
    region,
    topLevelDomain,
    currencies,
    capital,
    population,
    languages,
    name,
    flags,
    subregion,
    borders,
  } = country;

  const { svg } = flags;
  const { name: currName } = currencies[0];
  const { countries } = useContext(CountriesContext);
  const { mode } = useContext(ModeContext);
  return (
    <div className={`country ${mode ? `country-dark` : ``}`}>
      <div className={`country__cta ${mode ? `country-dark__cta` : ``}`}>
        <Link
          className={`country__cta--btn ${
            mode ? `country-dark__cta--btn` : ``
          }`}
          to={"/"}
        >
          &larr; Back
        </Link>
      </div>
      <div className={`country__data ${mode ? `country-dark__data` : ``}`}>
        <div className="country__data--flag">
          <img src={svg} className="country__data--flag--img" alt={`${name}`} />
        </div>
        <div
          className={`country__data--info ${
            mode ? ` country-dark__data--info` : ``
          }`}
        >
          <h3
            className={`country__data--info--heading ${
              mode ? `country-dark__data--info--heading` : ``
            }`}
          >
            {name}
          </h3>
          <div
            className={`country__data--info--data ${
              mode ? `country-dark__data--info--data` : ``
            }`}
          >
            <p className="country__data--info--data--item ">
              <span>NativeName: </span>
              {nativeName}
            </p>
            <p className="country__data--info--data--item ">
              <span>Population: </span>
              {population}
            </p>
            <p className="country__data--info--data--item ">
              <span>Region: </span>
              {region}
            </p>
            <p className="country__data--info--data--item ">
              <span>Sub Region: </span>
              {subregion}
            </p>
            <p className="country__data--info--data--item ">
              <span>Capital: </span>
              {capital}
            </p>
            <p className="country__data--info--data--item ">
              <span>Top Level Domain: </span>
              {topLevelDomain}
            </p>
            <p className="country__data--info--data--item ">
              <span>Currencies: </span>
              {currName}
            </p>
            <p className="country__data--info--data--item ">
              <span>Languages: </span>
              {languages.map(({ name }) => `${name},`)}
            </p>
          </div>
          {!borders ? (
            <Fragment></Fragment>
          ) : (
            <div
              className={`country__data--info--borders ${
                mode ? ` country-dark__data--info--borders` : ``
              }`}
            >
              <p
                className={`country__data--info--borders--title ${
                  mode ? ` country-dark__data--info--borders--title` : ``
                }`}
              >
                Borders:
              </p>
              <div
                className={`country__data--info--borders--items ${
                  mode ? ` country-dark__data--info--borders--items` : ``
                }`}
              >
                {borders.map((border) =>
                  countries
                    .filter((country) => country.alpha3Code === border)
                    .map((country) => (
                      <Link
                        className={`country__data--info--borders--items--link ${
                          mode
                            ? `country-dark__data--info--borders--items--link`
                            : ``
                        }`}
                        to={`/countries/${country.name}`}
                      >
                        {country.name}
                      </Link>
                    ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CountryData;
